<template>
  <v-container fluid fill-height class="page__login page__reset-password px-3">
    <v-layout align-center justify-center>
      <div class="login">
        <img src="@/assets/img/99icon_black.svg" alt="99 Empresas" title="99 Empresas" class="login__brand">
        <form class="login__form form--custom" @submit.prevent="handleSubmit" novalidate>
          <h2 class="login__title">
            {{
              routeName === 'FirstAccessLogin'
                ? $t(`${namespace}.firstAccessTitle`)
                : $t(`${namespace}.title`)
            }}
          </h2>

          <p class="login__text">
            {{
              routeName === 'FirstAccessLogin'
                ? $t(`${namespace}.firstAccessText`)
                : $t(`${namespace}.text`)
            }}
          </p>

          <div @click="tooglePasswordVisibility($event, 'password')">
            <label for="">{{ $t(`${namespace}.newPasswordLabel`) }}</label>
            <v-text-field
              v-model="password"
              :type="passwordInputType ? 'password' : 'text'"
              name="password"
              placeholder="• • • • • • • •"
              :append-icon="passwordInputType ? 'remove_red_eye' : 'visibility_off'"
              title=""
              :disabled="submitted"
              v-validate="{
                required: true,
                hasValidPassword: true,
                min: 8
              }"
              :error-messages="errors.collect($t(`${namespace}.newPassword`))"
              :data-vv-name="$t(`${namespace}.newPassword`)"
              ref="senha"
              required
              flat
              outline
              solo
            />
          </div>

          <div @click="tooglePasswordVisibility($event, 'confirmPassword')">
            <label for="">{{ $t(`${namespace}.passwordConfirmLabel`) }}</label>
            <v-text-field
              v-model="passwordConfirm"
              :type="confirmPasswordInputType ? 'password' : 'text'"
              name="password"
              placeholder="• • • • • • • •"
              :append-icon="confirmPasswordInputType ? 'remove_red_eye' : 'visibility_off'"
              :disabled="submitted"
              v-validate="'required|confirmed:senha'"
              :error-messages="errors.collect($t(`${namespace}.passwordConfirm`))"
              :data-vv-name="$t(`${namespace}.passwordConfirm`)"
              required
              flat
              outline
              solo
            />
          </div>

          <div class="mb-4">
            <v-btn
              type="submit"
              color="warning--gradient"
              :disabled="submitted"
              :loading="submitted"
              round
              block
              depressed
              large
            >
              {{
                routeName === 'FirstAccessLogin'
                  ? $t(`${namespace}.firstAccessButtonLabel`)
                  : $t(`${namespace}.resetPassword`)
              }}
            </v-btn>
          </div>

          <PasswordTips class="mb-0" :password="password" />
        </form>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import userService from '@/services/user'
import Cookies from 'utils/Cookies'
import { SESSION_USER, SESSION_COMPANY, SESSION_HEADERS } from 'utils/constants'
import PasswordTips from 'components/PasswordTips'

export default {
  name: 'ResetPassword',
  components: {
    PasswordTips
  },
  computed: {
    routeName () {
      return this.$route.name
    },

    token () {
      return this.$route.params.token
    }
  },
  data () {
    return {
      namespace: 'Views.ResetPassword',
      passwordInputType: true,
      confirmPasswordInputType: true,
      password: null,
      passwordConfirm: null,
      submitted: false
    }
  },
  methods: {
    ...mapActions({
      clearAlert: 'snackbarAlert/clear',
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error',
      clearSelectedCompany: 'company/clearSelectedCompany',
      clearUserClaims: 'userClaims/clear'
    }),

    tooglePasswordVisibility (event, type) {
      if (event.target.classList.contains('v-icon')) {
        if (type === 'password') {
          this.passwordInputType = !this.passwordInputType
        }

        if (type === 'confirmPassword') {
          this.confirmPasswordInputType = !this.confirmPasswordInputType
        }
      }
    },

    resetFields () {
      this.password = null
      this.passwordConfirm = null
    },

    resetUserSession () {
      Cookies.set(SESSION_USER, '', 0)
      localStorage.removeItem(SESSION_COMPANY)
      localStorage.removeItem(SESSION_HEADERS)
      this.$store.state.session.status.loggedIn = false
      this.$store.state.session.user = {}
      this.clearUserClaims()
      this.clearSelectedCompany()
    },

    async handleSubmit () {
      const { token, password } = this
      this.clearAlert()

      try {
        const isValid = await this.$validator.validateAll()
        if (!isValid) return

        this.submitted = true
        await userService.resetPassword({
          token,
          newPassword: password
        })

        this.submitted = false

        const successMessage = this.routeName === 'FirstAccessLogin'
          ? this.$t(`${this.namespace}.firstAccessSuccess`)
          : this.$t(`${this.namespace}.resetPasswordSuccess`)
        this.successAlert(successMessage)
        this.$router.push({ name: 'Login' })
      } catch (error) {
        this.submitted = false
        const errorMessage = this.routeName === 'FirstAccessLogin'
          ? this.$t(`${this.namespace}.firstAccessError`)
          : this.$t(`${this.namespace}.resetPasswordError`)
        this.errorAlert(errorMessage)
        console.log('Error', error)
      }
    }
  },
  created () {
    this.resetUserSession()

    this.$validator.extend('hasValidPassword', {
      getMessage: field => this.$t(`${this.namespace}.passwordDefaultError`),
      validate: value => {
        function isValid (text) {
          const rules = {
            charsCount: text.length >= 8,
            lowerCase: /(?=.*[a-z])/.test(text),
            upperCase: /(?=.*[A-Z])/.test(text),
            number: /(?=.*[0-9])/.test(text),
            specialChars: /(?=.*[?!@#$%^&*()_\-+=`~[\]{}:;'<>/\\]+)/.test(text)
          }

          return rules.charsCount && rules.lowerCase && rules.upperCase && rules.number && rules.specialChars
        }

        return isValid(value)
      }
    })
  },
  mounted () {
    if (!this.token) {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page__login {
  padding: 0 16px;
}
</style>
